// extracted by mini-css-extract-plugin
export default {"line":"LineAngel_line__YCz7r"};